import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { InactivityService, SecurityService } from 'src/app/services';
import { Constants } from 'src/app/shared/models/constants';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(
    private router: Router,
    private securityService: SecurityService,
    private inactivityService: InactivityService    
  ) { }
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.securityService.currentUserValue;
    if (currentUser) {
      if (!this.inactivityService.IsStarted()) {
        this.inactivityService.setIdleSessionTimeOut();
      }
      /* authorized so return true*/
      return true;
    }
    this.securityService.clearLocalStorage();
    localStorage.setItem(Constants.LOCALSTORE_RETURNURL, state.url);
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
